export default __webpack_public_path__ + "static/media/ted1.58376f14.jpg";